import Vue from 'vue'
import store from '../store'
import VueRouter from 'vue-router'
import OrdersView from "@/views/OrdersView";
import LoginView from "@/views/LoginView";
import NewReservationView from "@/views/dashboard/NewReservationView";
import DashboardView from "@/views/DashboardView";
import CalendarView from "@/views/dashboard/CalendarView";
import PaymentsView from "@/views/PaymentsView";
import NewOrderView from "@/views/dashboard/NewOrderView";
import OrderDetailView from "@/components/order/OrderDetailView";
import InvoiceDetailView from "@/components/invoice/InvoiceDetailView";
import CustomerDetailView from "@/components/customer/CustomerDetailView";
import ReservationDetailView from "@/components/reservation/ReservationDetailView";
import NewXTROrderView from "@/views/dashboard/NewXTROrderView";
import AdjustmentsView from "@/components/controlling/adjustments/AdjustmentsView";
import ReservationListView from "@/views/ReservationListView";
import VoucherDetailView from "@/components/voucher/VoucherDetailView";
import InvoiceCreditView from "../views/InvoiceCreditView.vue";
import VoucherGeneratorView from "../views/VoucherGeneratorView.vue";

Vue.use(VueRouter)

const routes = [
    {
        path: '/anmelden',
        name: 'login',
        component: LoginView
    },
    {
        path: '/',
        name: 'home',
        component: DashboardView
    },
    {
        path: '/reservierungen',
        name: 'reservationList',
        component: ReservationListView
    },
    {
        path: '/reservierung/:id',
        name: 'reservationDetail',
        props: true,
        component: ReservationDetailView
    },
    {
        path: '/gutschein-generieren',
        name: 'voucherGenerator',
        props: true,
        component: VoucherGeneratorView
    },
    {
        path: '/rechnung/:id',
        name: 'invoiceDetail',
        props: true,
        component: InvoiceDetailView
    },
    {
        path: '/kunde/:id',
        name: 'customerDetail',
        props: true,
        component: CustomerDetailView
    },
    {
        path: '/bestellungen',
        name: 'orders',
        component: OrdersView
    },
    {
        path: '/bestellung/:id?',
        name: 'orderDetail',
        props: true,
        component: OrderDetailView
    },
    {
        path: '/reservierung-erfassen',
        name: 'newReservation',
        component: NewReservationView
    },
    {
        path: '/bestellung-erfassen',
        name: 'newOrder',
        component: NewOrderView
    },
    {
        path: '/gutschrift/:invoiceId',
        name: 'creditOnInvoice',
        props: true,
        component: InvoiceCreditView
    },
    {
        path: '/bestellung-erfassen-xtr',
        name: 'newOrderXTR',
        component: NewXTROrderView
    },
    {
        path: '/gutschein/:id',
        name: 'voucherDetail',
        props: true,
        component: VoucherDetailView
    },
    {
        path: '/reservierungskalender',
        name: 'reservationCalendar',
        component: CalendarView
    },
    {
        path: '/operations-modus',
        name: 'operatingMode',
        component: () => import('../views/OperatingModeView')
    },
    {
        path: '/zahlungsverkehr',
        name: 'payments',
        component: PaymentsView,
        meta: {
            section: 'accounting'
        }
    },
    {
        path: '/anpassungen',
        name: 'adjustments',
        component: AdjustmentsView,
        meta: {
            section: 'accounting'
        }
    },
    /* Produkte */
    {
        path: '/produkte',
        name: 'listProducts',
        component: () => import('../views/ProductListView'),
    },
    {
        path: '/produkt/:productId?',
        name: 'editProduct',
        component: () => import('../views/ProductEditView'),
        props: true
    },
    /* Artikel */
    {
        path: '/artikel',
        name: 'bulkEditArticles',
        component: () => import('../components/shop/ArticleBulkEditView'),
    },
    {
        path: '/subscriptions',
        name: 'subscriptions',
        component: () => import('../views/SubscriptionsView'),
    },
    {
        path: '/taxes',
        name: 'taxes',
        component: () => import('../views/TaxView.vue'),
    },
    {
        path: '/drive',
        name: 'drive',
        component: () => import('../views/GoogleDriveView'),
        props: true
    },
    {
        path: '/product-availabilities',
        name: 'productAvailabilities',
        component: () => import('../views/ProductAvailabilityView'),
        props: true
    },
    {
        path: '/drive-upload',
        name: 'drive-upload',
        component: () => import('../views/GoogleDriveUploadView'),
        props: true
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    if (to.name !== 'login' && !store.getters.loggedIn) {
        console.log('trying autoLogin')
        const _store = store
        store.dispatch('autoLogin').then(() => {
            if (!_store.getters.loggedIn) {
                console.log('autoLogin failed')
                next({name: 'login'})
            } else {
                console.log('autoLogin successful')
                next()
            }
        }).catch((err) => {
            store.dispatch('handleError', err)
            next({name: 'login'})
        })
    } else
        next()
})

export default router
